module.exports = __webpack_public_path__ + "static/media/pendingIcon.892243b0.svg";